import styled from 'styled-components';

export const ActionsAnchor = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

export const ActionsMenuPosition = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 30;
`;
